import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import {
  createCompanyStatus,
  deleteCompanyStatus,
  updateCompanyStatus,
} from '../../../../store/business/CompanyStatusReducer'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const CompanyStatusForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.companyStatus)
  const dispatch = useAppDispatch()

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createCompanyStatus(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateCompanyStatus(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteCompanyStatus(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

CompanyStatusForm.displayName = 'CompanyStatusForm'

export default CompanyStatusForm
